import type { AuthorBlock as AuthorBlockType } from "@/types";

export function AuthorBlock({ block }: { block: AuthorBlockType }) {
  const { name, role, note, photo_url } = block.props;
  const initials = (name || "?")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join("");

  return (
    <section className="block block--author">
      <div className="block--author__head">
        {photo_url ? (
          <img className="block--author__photo" src={photo_url} alt={name || ""} loading="lazy" />
        ) : (
          <span className="block--author__photo block--author__photo--placeholder" aria-hidden="true">
            {initials}
          </span>
        )}
        <div>
          {name ? <p className="block--author__name">{name}</p> : null}
          {role ? <p className="block--author__role">{role}</p> : null}
        </div>
      </div>
      {note ? <p className="block--author__note">{note}</p> : null}
    </section>
  );
}
